// extracted by mini-css-extract-plugin
export default {"btn":"WordGuessKeyboard_btn__bLD3y","active":"WordGuessKeyboard_active__DD7MT","inactive":"WordGuessKeyboard_inactive__DyXv1"};